"use client";

import { Card, CardContent } from "@/components/ui/card";

interface AgentDataCardProps {
  title: string;
  data: any;
}

/**
 * Displays structured data returned by the agent
 * Used for showing streams, quotes, credits, etc.
 */
export function AgentDataCard({ title, data }: AgentDataCardProps) {
  // Handle different data types
  const renderData = () => {
    if (Array.isArray(data)) {
      return (
        <div className="space-y-2">
          {data.map((item, index) => (
            <div
              key={index}
              className="p-3 bg-gray-800/50 rounded-lg border border-gray-700"
            >
              {typeof item === "object" ? (
                <div className="space-y-1 text-sm">
                  {Object.entries(item).map(([key, value]) => (
                    <div key={key} className="flex justify-between">
                      <span className="text-gray-400">{key}:</span>
                      <span className="text-white font-medium">
                        {String(value)}
                      </span>
                    </div>
                  ))}
                </div>
              ) : (
                <p className="text-white text-sm">{String(item)}</p>
              )}
            </div>
          ))}
        </div>
      );
    }

    if (typeof data === "object" && data !== null) {
      return (
        <div className="space-y-2">
          {Object.entries(data).map(([key, value]) => (
            <div key={key} className="flex justify-between items-center">
              <span className="text-gray-400 text-sm">{key}:</span>
              <span className="text-white font-medium">
                {typeof value === "object"
                  ? JSON.stringify(value)
                  : String(value)}
              </span>
            </div>
          ))}
        </div>
      );
    }

    return <p className="text-white">{String(data)}</p>;
  };

  return (
    <Card className="bg-gray-800/30 border-gray-700">
      <CardContent className="pt-4">
        {title && (
          <h4 className="text-sm font-semibold text-purple-400 mb-3">
            {title}
          </h4>
        )}
        {renderData()}
      </CardContent>
    </Card>
  );
}
